import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { Box, BoxLevel, CardTemplate, Character } from '@df/interfaces';

import { PrepareBoxService } from '@app/core/services/prepare-box.service';
import { FileService } from '@app/core/services/file.service';
import { PrivilegeService } from '@app/core/services/privilege.service';

@Component({
    selector: 'app-preview-img',
    templateUrl: './preview-img.component.html',
    styleUrls: ['./preview-img.component.scss']
})
export class PreviewImgComponent implements OnInit, OnChanges {
    @Input() cardsFormat: string;
    @Input() cardTemplate: CardTemplate;
    @Input() box: Box;
    @Input() boxLevels: Array<BoxLevel>;
    @Input() character: Character;
    @Input() lessonDate: Date;

    constructor(private boxSvc: PrepareBoxService, private filesSvc: FileService, private prvSvc: PrivilegeService) {}

    public ngOnInit(): void {
        this.boxSvc.oneBoxChange.subscribe(box => {
            if (this.box.title === box.title) {
                this.box = box;
                this.getCharacter(this.box);
                this.box.files = this.filesSvc.getFilesForBox(this.box.title);
            }
        });
        this.filesSvc.filesForBoxChanged.subscribe(() => {
            this.box.files = this.filesSvc.getFilesForBox(this.box.title);
        });
    }

    public ngOnChanges(simpleChanges: SimpleChanges): void {
        if (simpleChanges.box) {
            const box: Box = simpleChanges.box.currentValue;
            this.getCharacter(box);
        }
    }

    getCharacter(box: Box) {
        if (box.sell_character_obj) {
            this.character = box.sell_character_obj;
        } else if (box.sell_character) {
            this.prvSvc.getCharacter(this.box.sell_character).subscribe(response => {
                this.character = response;
            });
        }
    }
}
